/* LINE（TOPだけ・2026-10-02）：やりとりの例を流す。
   ・トークが画面に入ったら、あいさつ → 「お買い物の相談」のやりとりを1回だけ流す（自動で次へは進まない）
   ・下のボタンで話題を選ぶと、そのやりとりを流す。お店の返事の前に「入力中…」
   ・引換券が画面に入ったら、版がずれて朱の「和」を押す
   ・動きを減らす設定では、最初から全部出ている
   2026-10-03：やりとりは2つずつに。スマホの切り替え（試作）を追加 */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (el) => {
    if (el.dataset.klbOn) return;
    el.dataset.klbOn = '1';
    const chat = el.querySelector('.klb-chat');
    const convos = [...el.querySelectorAll('.klb-convo')];
    const btns = [...el.querySelectorAll('.klb-quick__btn')];
    let timers = [];

    /* いちばん長いやりとりの高さで固定（話題を変えてもページが動かない） */
    /* 測る前に固定をはずし、流れている途中の「入力中…」は数えない（画面の高さが変わっても、空きが残ったり、高さが増え続けたりしない） */
    const fit = () => {
      if (!chat) return;
      chat.style.minHeight = '';
      const typing = [...chat.querySelectorAll('.klb-typing')];
      typing.forEach((t) => { t.style.display = 'none'; });
      const hidden = [...chat.querySelectorAll('.is-wait')];
      hidden.forEach((b) => b.classList.remove('is-wait'));
      chat.style.minHeight = `${Math.max(...convos.map((c) => c.offsetHeight))}px`;
      hidden.forEach((b) => b.classList.add('is-wait'));
      typing.forEach((t) => { t.style.display = ''; });
    };
    fit();
    let rt;
    window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(fit, 200); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    const typing = () => {
      const t = document.createElement('div');
      t.className = 'klb-bubble klb-bubble--shop klb-typing is-pop';
      t.setAttribute('aria-hidden', 'true');
      t.innerHTML = '<span class="klb-avatar">和</span><p><i></i><i></i><i></i></p>';
      return t;
    };
    const stop = () => {
      timers.forEach(clearTimeout);
      timers = [];
      el.querySelectorAll('.klb-typing').forEach((t) => t.remove());
    };
    const show = (b) => { b.classList.remove('is-wait'); b.classList.add('is-pop'); };

    const play = (topic, animate) => {
      stop();
      btns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.topic === topic)));
      convos.forEach((c) => c.classList.toggle('is-on', c.dataset.topic === topic));
      const c = convos.find((x) => x.dataset.topic === topic);
      if (!c) return;
      const bs = [...c.children].filter((b) => b.classList.contains('klb-bubble'));
      bs.forEach((b) => b.classList.remove('is-pop'));
      if (!animate || reduce) { bs.forEach((b) => b.classList.remove('is-wait')); return; }
      bs.forEach((b) => b.classList.add('is-wait'));
      let t = 250;
      bs.forEach((b) => {
        if (b.classList.contains('klb-bubble--shop')) {
          const ty = typing();
          timers.push(setTimeout(() => b.before(ty), t));
          t += 1000;
          timers.push(setTimeout(() => { ty.remove(); show(b); }, t));
          t += 800;
        } else {
          timers.push(setTimeout(() => show(b), t));
          t += 750;
        }
      });
    };

    btns.forEach((b) => {
      b.addEventListener('click', () => play(b.dataset.topic, true));
      /* キーボードで選んだ話題のボタンが、横に送る列の外に半分隠れないように */
      b.addEventListener('focus', () => b.scrollIntoView({ block: 'nearest', inline: 'nearest' }));
    });

    /* 試作（data-klb-mobile="tabs"）：スマホは「やりとりの例｜お友だち特典」を切り替え。特典を開いたら、版ずれと朱の印をもう一度 */
    el.querySelectorAll('.klb-mtabs__btn').forEach((t, _, all) => t.addEventListener('click', () => {
      el.dataset.klbPanel = t.dataset.klbPanel;
      all.forEach((x) => x.setAttribute('aria-selected', String(x === t)));
      if (t.dataset.klbPanel === 'ticket') { el.classList.remove('has-badge'); el.dataset.klbSeen = '1'; }
      if (t.dataset.klbPanel === 'ticket' && el.classList.contains('is-armed')) {
        el.classList.remove('is-stamped');
        void el.offsetWidth;
        el.classList.add('is-stamped');
      }
    }));

    if (reduce || !('IntersectionObserver' in window)) { el.classList.add('has-badge'); return; }
    el.classList.add('is-armed');
    /* 最初のやりとりは、トークが見えるまで隠しておく */
    const first = convos.find((c) => c.classList.contains('is-on'));
    if (first) [...first.children].forEach((b) => b.classList.add('is-wait'));
    const on = (target, fn) => {
      if (!target) { fn(); return; }
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        fn();
      }), { threshold: .35, rootMargin: '0px 0px -8% 0px' });
      io.observe(target);
    };
    on(el.querySelector('.klb-talk'), () => {
      el.classList.add('is-in');
      if (first) timers.push(setTimeout(() => play(first.dataset.topic, true), 700));
      /* やりとりが流れ終わったころ、特典のタブに朱の「1」（まだ開いていなければ） */
      setTimeout(() => { if (!el.dataset.klbSeen) el.classList.add('has-badge'); }, 4600);
    });
    on(el.querySelector('.klb-ticket'), () => el.classList.add('is-stamped'));
  };
  const run = () => document.querySelectorAll('[data-klb-talk]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
})();
